// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-header-warning[data-v-87e1f04a]{background:#0086cc;color:#fff;font-size:14px;line-height:21px;padding:20px}.modal-header-warning a[data-v-87e1f04a]{color:#fff}@media screen and (max-width:550px){.modal-header-warning[data-v-87e1f04a]{font-size:12px;line-height:16px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
